<template>
    <VueMultiselect
        :disabled="disabled"
        v-model="value"
        :options="Options"
        :multiple="false"
        :allowEmpty="false"
        selectLabel=""
        deselectLabel=""
        selectedLabel=""
        :close-on-select="true" :clear-on-select="false"
        class="next-vue-multiselect-single"
        track-by="id" label="text">
        <template v-slot:noResult>Nessun elemento trovato.</template>
    </VueMultiselect>
</template>

<script lang="ts">
import {Options, Vue} from 'vue-class-component';
import {Watch} from 'vue-property-decorator/lib/decorators/Watch';

@Options({
    name: 'Select',
    components: {},
    props: {
        modelValue: [Number, Boolean, String],
        options: [Array],
        disabled: Boolean
    }
})
export default class Alert extends Vue {
    options: any
    value: any = this.Options[0]

    get Options() {
        if (this.options) {
            return this.options
        }
        return [
            {id: false, text: 'No'},
            {id: true, text: 'Sì'},
        ]
    }

    @Watch('value')
    val(new_value: any, old: any) {
        this.$emit('update:modelValue', new_value ? new_value.id : null)
    }

    @Watch('modelValue')
    mod(new_value: any) {
        this.value = this.Options.find((el: any) => {
            return new_value == el.id
        })
    }

    created() {
        //@ts-ignore
        this.mod(this.modelValue)
    }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
</style>
